import { NotificationReward, RewardType } from '../../state/rewards.types';

const isCashReward = ({ rewardType }: NotificationReward) =>
    rewardType === RewardType.Cash || rewardType === RewardType.Bonus;

export const formatRewardAmount = (reward: NotificationReward) => {
  if (isCashReward(reward)) {
    return `$` + reward.rewardAmount;
  }

  return reward.rewardAmount;
};
